import { SHORTCUT_DELIVERY_ZONE_FIELDS } from '@@partner:graphql/shortcuts'
import { DeliveryZone } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useQuery } from '@apollo/client'

type Variables = {
  id?: GQL_ID | null
}

type Query = {
  singleDeliveryZone: DeliveryZone
}



export const GQL_QUERY_SINGLE_DELIVERY_ZONE = gql`
  query singleDeliveryZone ($id: ID!) {
    singleDeliveryZone(id: $id) {
      ${SHORTCUT_DELIVERY_ZONE_FIELDS}
    }
  }
`

export const useFetchSingleDeliveryZone = (variables: Variables) => useQuery<Query, Variables>(GQL_QUERY_SINGLE_DELIVERY_ZONE, {
  variables,
  fetchPolicy: 'network-only',
  skip: !variables.id
})